import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RequiredServicesService } from 'app/view/clients/components/required-services/required-services.service';
import { EmployeesService } from 'app/view/employees/services/employees.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  styleUrls: ['./add-site.component.scss']
})
export class AddSiteComponent implements OnInit {
  workSitesForm: FormGroup;
  ListOfCountries: any[] = [];
  listOfStates: any[] = [];
  listOfRegion: any[] = [];
  loadingWorkSite: boolean = false;
  lableForm: boolean = false;
  submit: boolean = false;
  workSiteId: number = 0;

  constructor(    private _formBuilder: FormBuilder,
    private _EmployeesService: EmployeesService,
    private _RequiredServicesService: RequiredServicesService,
    private modalService: NgbModal,
    private toastrService: ToastrService,


  ) {

    this.workSitesForm = this._formBuilder.group({
      nameOfSite: [''],
      numOfShifts: [0],
      numOfEmployees: [0],
      streetAddress1: [null],
      streetAddress2: [null],
      postalCode: [null],
      addressInDetails: [null],
      note: [null],
      region_Id: [null, [Validators.required]],
      state_Id: [null, [Validators.required]],
      country_Id: [null, [Validators.required]],
      client_Id: [null, [Validators.required]],
    });
    this.getListOfCountries();
  }

  ngOnInit(): void {
  }

  onSubmit() {
    // this.loadingWorkSite = true;
    if (!this.lableForm && this.workSitesForm.invalid) {
      return
    } else {
      this.submit = true;
      !this.lableForm ? this.AddClientWorkSite() : this.UpdateClientWorkSite();
    }
  }
  patchValueForm(content: any, obj: any) {
    this.lableForm = true;
    this.getListOfStates(obj.country_Id);
    this.getListOfRegions(obj.state_Id);
    this.workSitesForm.patchValue(obj)
    this.modalService.open(content, {
      centered: true,
      size: 'lg'
    });
  }
  UpdateClientWorkSite(): void {
    let value = this.workSitesForm.value
    value['id'] = this.workSiteId;
    console.log('update',value)
    // this._RequiredServicesService.UpdateClientWorkSite(value).subscribe({
    //   next: (res: any) => {
    //     // this.GetAllClientWorkSites();
    //     this.loadingWorkSite = false;
    //     this.modalService.dismissAll();
    //     this.toastrService.success(res.message);
    //   }, error: (err: Error) => {
    //     this.loadingWorkSite = false;
    //     this.toastrService.error(`${err.message}`);
    //   }
    // })
  }

  AddClientWorkSite(): void {
    let value = this.workSitesForm.value;
    // this._RequiredServicesService.AddClientWorkSite(value).subscribe({
    //   next: (res: any) => {
    //     // this.GetAllClientWorkSites();
    //     this.loadingWorkSite = false;
    //     this.modalService.dismissAll();
    //     this.toastrService.success(res.message);
    //   }, error: (err: Error) => {
    //     this.loadingWorkSite = false;
    //     this.toastrService.error(`${err.message}`);
    //   }
    // })
    console.log(value)
    console.log(this.lableForm)
  }
  getListOfCountries(): void {
    this._EmployeesService.ListOfCountries().subscribe({
      next: (res: any) => {
        this.ListOfCountries = res.data;
      }
    })
  }
  getListOfStates(countryId: number): void {
    countryId ?
      this._EmployeesService.ListOfStates(countryId).subscribe({
        next: (res: any) => {
          this.listOfStates = res.data;
          this.workSitesForm.get('state_Id').setValue(null);
          this.workSitesForm.get('region_Id').setValue(null);
        }
      }) : this.listOfStates = [];
  }
  getListOfRegions(stateID: number): void {
    stateID ?
      this._EmployeesService.ListOfRegions(stateID).subscribe({
        next: (res: any) => {
          this.listOfRegion = res.data;
          this.workSitesForm.get('region_Id').setValue(null);

        }
      }) : this.listOfRegion = [];
  }
}
